import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { AdminBatchListItem } from "@shared-kernel/application/ports/admin/admin-repository";
import {
  adminRetrieveAllBatches,
  resetAdminRetrieveAllBatches,
} from "@academy-context/read/application/use-cases/admin/all-batches-retrieval/retrieve-all-batches";

const initialState: RetrievalState<AdminBatchListItem[]> = { data: [], fetching: "idle" };

export const adminRetrieveAllBatchesReducer = createReducer<RetrievalState<AdminBatchListItem[]>>(initialState, builder => {
  builder.addCase(adminRetrieveAllBatches.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(adminRetrieveAllBatches.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(adminRetrieveAllBatches.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
  builder.addCase(resetAdminRetrieveAllBatches, () => {
    return initialState;
  });
});
